import React from 'react';

export const pageMeta = {
  "name": "Function Bind",
  "link": "/javascript/functions/bind"
};

export default function JavascriptFunctionsBind() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Function Bind</h2>
      <p>Route: /javascript/functions/bind</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
